import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, concat, delay, Observable, of, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  public translatedArray: any = [];
  public languageType: string = '';
  public translationContent = new BehaviorSubject<any>(this.translatedArray);
  public sharetranslationData = this.translationContent.asObservable();
  public languageContent = new BehaviorSubject<any>(this.languageType);
  public sharelanguageType = this.languageContent.asObservable();
  private _featureFlags: any = null;
  private _supportedLanguagesForDisplay: any[] = [];
    supportedLanguages: any;
  private _bpSecrets: {hereMapApiKey: any, gMapApiKey:any} = {hereMapApiKey: undefined, gMapApiKey:undefined};
  private readonly _loadMapSubject = new BehaviorSubject<boolean>(false);

  constructor(private readonly httpClient: HttpClient) { }
  sendtranslationValue(value: any) {
    this.translationContent.next(value);
  }
  sendSelectedLanguage(value: any) {
    this.languageContent.next(value);
  }

  setTranslationData(data: any) {
    this.translatedArray = data;
  }
  getTranslationData() {
    return this.translatedArray;
  }


  setLoadMap(load: boolean): void {
    this._loadMapSubject.next(load);
  }

  getLoadMap() {
    return this._loadMapSubject.asObservable()
  }

  public set featureFlags(flags: any) {
    this._featureFlags = flags;
  }

  public get featureFlags() {
    return this._featureFlags;
  }

  /**
   * @description To be replaced by actual API. Gives list of all supported languages
   * @returns list of languages
   * !IMPORTANT: While testing with actual API, ensure error scenarios are also handled
   */
  public getAllSupportedLanguages(): Observable<any> {
    const res = require('../../shared/components/language-selection/language-list.json');
    return of(res).pipe(delay(800));
  }

  public set supportedLanguagesForDisplay(languages: any[]) {
    const defaultLangs = ['en', 'de'];
    const langCodes = languages.map(lang => lang.localeCode);
    langCodes.push(...defaultLangs);
    this.setSupportedLanguageByCode(langCodes);
    this._supportedLanguagesForDisplay = languages;
  }

  public get supportedLanguagesForDisplay(): any[] {
    return this._supportedLanguagesForDisplay;
  }

  public getBpSecretsFromKeyVault(): Observable<any> {
    const url = `${environment.proxyUrl}/businessPortal/accessKeys/accessBusinessPortalKeys`;
    return this.httpClient.get<any>(url);
  }

  public set allSecrets(secrets: any) {
    this._bpSecrets = secrets;
  }

  public get allSecrets(): any {
    return this._bpSecrets;
  }

  public getBpConfigurations(): void {
    if (!this._bpSecrets.hereMapApiKey || !this._bpSecrets.gMapApiKey) {
      this.getBpSecretsFromKeyVault().subscribe((secrets: any) => {
          this.allSecrets = secrets;
          this.setLoadMap(true)
      })
    }
  }

  public getAllFeatureFlags(): Observable<any> {
    let featureFlags = require('../../shared/feature-toggle/feature-toggle.prod.json')
    if (environment.environment==='dev') { 
      featureFlags = require('../../shared/feature-toggle/feature-toggle.json');
    }else if(environment.environment==='int'){
      featureFlags = require('../../shared/feature-toggle/feature-toggle.int.json');
    }
    return of(featureFlags).pipe(delay(800));
  }

  public setSupportedLanguageByCode(languages: string[]) {
    this.supportedLanguages = languages;
  }

  public getSupportedLanguageByCode(): string[] {
    this.supportedLanguages = this.supportedLanguages ?? ['en-GB', 'de-DE'];
    return this.supportedLanguages;
  }
}
